angular.module('app.casosService', [])
.factory('casosService', ['$http', '$q', 'appSettings', function ( $http, $q, appSettings ) 
{
  return {
  /*---------------TC_MATERIA---------------*/
  getMateriaDespacho: function(p_id_despacho) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/despacho/'+p_id_despacho+'/getMateriaDespacho')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*---------------TC_MATERIA---------------*/   

  /*-------------TC_TIPO_PROCESO------------*/
  getTipoProcesoMateriaDespacho: function(p_id_despacho,p_id_materia) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/despacho/'+p_id_despacho+
                                                           '/materia/'+p_id_materia+'/getTipoProcesoMateriaDespacho')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*-------------TC_TIPO_PROCESO------------*/

  /*-----------TS_TIPO_PROCEDENCIA----------*/
  getTipoProcedencia: function( p_id_materia ) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/materia/'+p_id_materia+'/getTipoProcedencia')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*-----------TS_TIPO_PROCEDENCIA----------*/

  /*--------------TC_PROCEDENCIA------------*/
  getProcedenciaTipoProcedencia: function(p_id_tipo_procedencia,p_id_materia,p_id_despacho) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/tipoProcedencia/'+p_id_tipo_procedencia+
                                                           '/materia/'+p_id_materia+
                                                           '/centro/'+p_id_despacho+'/getProcedenciaTipoProcedencia')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*--------------TC_PROCEDENCIA------------*/
  
  /*--------------TS_TIPO_SUJETO------------*/
  getTipoSujeto: function( data ) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/getTipoSujeto')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*--------------TS_TIPO_SUJETO------------*/

  /*-----------TS_PRIORIDAD_SUJETO----------*/
  getPrioridadSujeto: function( data ) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/getPrioridadSujeto')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*-----------TS_PRIORIDAD_SUJETO----------*/

  /*---------TS_TIPO_IDENTIFICACION---------*/
  getTipoIdentificacion: function(p_id_tipo_sujeto) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/tipoSujeto/'+p_id_tipo_sujeto+'/getTipoIdentificacion')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*---------TS_TIPO_IDENTIFICACION---------*/

  /*-------------TS_GENERO/SEXO-------------*/
  getGenero: function( data ) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/getGenero')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*-------------TS_GENERO/SEXO-------------*/
  
  /*------------TS_TIPO_CONTACTO------------*/
  getTipoContacto: function( data ) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/getTipoContacto')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*------------TS_TIPO_CONTACTO------------*/

  /*------------TS_TIPO_CONTACTO------------*/
  getUbicacionGeografica: function(p_id_tipo_ubicacion,p_id_ubicacion_padre) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/tipoUbicacion/'+p_id_tipo_ubicacion+
                                                           '/tipoUbicacionPadre/'+p_id_ubicacion_padre+'/getUbicacionGeografica')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*------------TS_TIPO_CONTACTO------------*/

  /*-------------TS_ESTADO_CIVIL------------*/
  getEstadoCivil: function(p_id_sexo) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/sexo/'+p_id_sexo+'/getEstadoCivil')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*-------------TS_ESTADO_CIVIL------------*/

  /*------------TS_NACIONALIDAD-------------*/
  getNacionalidad: function(p_id_tipo_clasificacion_idioma,p_id_tipo_identificacion) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/tipoClasificacionIdioma/'+p_id_tipo_clasificacion_idioma+
                                                           '/tipoIdentificacion/'+p_id_tipo_identificacion+'/getNacionalidad')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*------------TS_NACIONALIDAD-------------*/

  /*-----------TS_TIPO_POBLACION------------*/
  getTipoPoblacion: function(p_id_nacionalidad,p_id_tipo_clasificacion_idioma) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/nacionalidad/'+p_id_nacionalidad+
                                                           '/tipoClasificacionIdioma/'+p_id_tipo_clasificacion_idioma+'/getTipoPoblacion/')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*-----------TS_TIPO_POBLACION------------*/

  /*---------------TC_IDIOMA----------------*/	
  getIdioma: function(p_id_nacionalidad,p_id_tipo_poblacion,p_id_tipo_clasificacion_idioma) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/nacionalidad/'+p_id_nacionalidad+
                                                           '/tipoPoblacion/'+p_id_tipo_poblacion+
                                                          '/tipoClasificacionIdioma/'+p_id_tipo_clasificacion_idioma+'/getIdioma')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*---------------TC_IDIOMA----------------*/	

  /*-----------TS_NIVEL_EDUCATIVO-----------*/
  getNivelEducativo: function( data ) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/getNivelEducativo')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*-----------TS_NIVEL_EDUCATIVO-----------*/

  /*--------------TC_PROFESION--------------*/
  getProfesion: function(p_id_sexo) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/sexo/'+p_id_sexo+'/getProfesion')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*--------------TC_PROFESION--------------*/

  /*--------------TC_DESPACHO---------------*/
  getDespacho: function( data ) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/getDespacho')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*--------------TC_DESPACHO---------------*/

  /*------------TS_DISCAPACIDAD-------------*/
  getDiscapacidad: function( data ) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/getDiscapacidad')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*------------TS_DISCAPACIDAD-------------*/

  /*-------TS_DOCUMENTO_HOMOLOGACION--------*/
  getDocumentosHomologacion: function( data ) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/getDocumentosHomologacion')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*-------TS_DOCUMENTO_HOMOLOGACION--------*/

  /*---------------TS_ESTADO----------------*/
  getEstadoSesion: function( p_opcion ) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/getEstadoSesion')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },

  getResultadoSesion: function( p_id_estado_sesion,p_requiere_expediente,p_id_tipo_sesion) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/estado_sesion/'+p_id_estado_sesion+
                                                           '/requiere_expediente/'+p_requiere_expediente+
                                                           '/tipo_sesion/'+p_id_tipo_sesion+'/getResultadoSesion')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*---------------TS_ESTADO----------------*/

  /*---------------ANIO_CASOS---------------*/
  getAnioCasos: function(p_id_despacho,p_opcion) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/despacho/'+p_id_despacho+'/opcion/'+p_opcion+'/getAnioCasos')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*---------------ANIO_CASOS---------------*/

  /*---TT_CENTRO_USUARIO/TT_USUARIO_CARGO---*/
  getMediadoresCentro: function(p_id_despacho,p_id_usuario,p_opcion) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Transacciones/despacho/'+p_id_despacho+
                                                               '/usuario/'+p_id_usuario+
                                                              '/opcion/'+p_opcion+'/getMediadoresCentro')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*---TT_CENTRO_USUARIO/TT_USUARIO_CARGO---*/

  /*------------TS_HORA/TT_SESION-----------*/
  getAgendaSesionesMediador: function(p_id_despacho,p_id_sesion,p_fecha_inicial,p_fecha_final,p_fecha_actual) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Transacciones/centro/'+p_id_despacho+
                                                               '/sesion/'+p_id_sesion+
                                                              '/fecha_inicial/'+p_fecha_inicial+
                                                             '/fecha_final/'+p_fecha_final+
                                                            '/fecha_actual/'+p_fecha_actual+'/getAgendaSesionesMediador')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },

  getFechaAgenda: function(p_id_despacho) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Transacciones/centro/'+p_id_despacho+'/getFechaAgenda')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },

  edtFijarAgenda: function( data ) 
  {
    var deferred = $q.defer();
    $http.post( appSettings.restApiServiceBaseUri + 'Transacciones/edtFijarAgenda',data)
    .then(successCallback, errorCallback);
    function successCallback(data)
    {
        deferred.resolve( data );
    }
    function errorCallback(error)
    {
        deferred.reject( error );
    }
    return deferred.promise;
  },
  /*------------TS_HORA/TT_SESION-----------*/

  /*---------TC_UBICACION_GEOGRAFICA--------*/
  getUbicacionNacimiento: function(codigo_ubicacion_geografica) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Transacciones/codigo_ubicacion_geografica/'+codigo_ubicacion_geografica+'/getUbicacionNacimiento')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*---------TC_UBICACION_GEOGRAFICA--------*/

  /*----------------DATOS_CASO--------------*/
  insCaso: function( data ) 
  {
    var deferred = $q.defer();
    $http.post( appSettings.restApiServiceBaseUri + 'Transacciones/insCaso',data)
    .then(successCallback, errorCallback);
    function successCallback(data)
    {
        deferred.resolve( data );
    }
    function errorCallback(error)
    {
        deferred.reject( error );
    }
    return deferred.promise;
  },
  edtCaso: function( data ) 
  {
    var deferred = $q.defer();
    $http.post( appSettings.restApiServiceBaseUri + 'Transacciones/edtCaso',data)
    .then(successCallback, errorCallback);
    function successCallback(data)
    {
        deferred.resolve( data );
    }
    function errorCallback(error)
    {
        deferred.reject( error );
    }
    return deferred.promise;
  },
  getCaso: function(p_id_expediente) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Transacciones/expediente/'+p_id_expediente+'/getCaso')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  getCasoCompleto: function(p_id_expediente,p_registro_inicial) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Transacciones/expediente/'+p_id_expediente+'/getCasoCompleto')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  getCasos: function(p_id_despacho,p_anio) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Transacciones/despacho/'+p_id_despacho+
                                                              '/anio/'+p_anio+'/getCasos')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*----------------DATOS_CASO--------------*/
  
  /*---------------DATOS_SUJETO-------------*/
  insSujeto: function( data ) 
  {
    var deferred = $q.defer();
    $http.post( appSettings.restApiServiceBaseUri + 'Transacciones/insSujeto',data)
    .then(successCallback, errorCallback);
    function successCallback(data)
    {
        deferred.resolve( data );
    }
    function errorCallback(error)
    {
        deferred.reject( error );
    }
    return deferred.promise;
  },
  delSujeto: function( data ) 
  {
    var deferred = $q.defer();
    $http.post( appSettings.restApiServiceBaseUri + 'Transacciones/delSujeto',data)
    .then(successCallback, errorCallback);
    function successCallback(data)
    {
        deferred.resolve( data );
    }
    function errorCallback(error)
    {
        deferred.reject( error );
    }
    return deferred.promise;
  },
  getDatosSujeto: function(p_id_expediente,p_id_sujeto,p_id_tipo_sujeto,p_sujeto_natural) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Transacciones/expediente/'+p_id_expediente+
                                                               '/sujeto/'+p_id_sujeto+
                                                              '/tipo_sujeto/'+p_id_tipo_sujeto+
                                                             '/sujeto_natural/'+p_sujeto_natural+'/getDatosSujeto')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  getDatosSujetoIdentificacion: function(p_id_tipo_sujeto,p_id_tipo_identificacion,p_identificacion) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Transacciones/tipo_sujeto/'+p_id_tipo_sujeto+
                                                               '/tipo_identificacion/'+p_id_tipo_identificacion+
                                                              '/identificacion/'+p_identificacion+'/getDatosSujetoIdentificacion')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*---------------DATOS_SUJETO-------------*/

  /*---------------DATOS_SESION-------------*/
  insSesion: function( data ) 
  {
    var deferred = $q.defer();
    $http.post( appSettings.restApiServiceBaseUri + 'Transacciones/insSesion',data)
    .then(successCallback, errorCallback);
    function successCallback(data)
    {
        deferred.resolve( data );
    }
    function errorCallback(error)
    {
        deferred.reject( error );
    }
    return deferred.promise;
  },
  edtSesion: function( data ) 
  {
    var deferred = $q.defer();
    $http.post( appSettings.restApiServiceBaseUri + 'Transacciones/edtSesion',data)
    .then(successCallback, errorCallback);
    function successCallback(data)
    {
        deferred.resolve( data );
    }
    function errorCallback(error)
    {
        deferred.reject( error );
    }
    return deferred.promise;
  },
  edtResultadoSesion: function( data ) 
  {
    var deferred = $q.defer();
    $http.post( appSettings.restApiServiceBaseUri + 'Transacciones/edtResultadoSesion',data)
    .then(successCallback, errorCallback);
    function successCallback(data)
    {
        deferred.resolve( data );
    }
    function errorCallback(error)
    {
        deferred.reject( error );
    }
    return deferred.promise;
  },
  getSujetosSesion: function(p_id_expediente,p_id_perfil_sujeto,p_tipo_juridico,p_id_sesion) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Transacciones/expediente/'+p_id_expediente+
                                                               '/perfil/'+p_id_perfil_sujeto+
                                                              '/tipo_juridico/'+p_tipo_juridico+
                                                             '/sesion/'+p_id_sesion+'/getSujetosSesion')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*---------------DATOS_SESION-------------*/

  /*------------DATOS_HOMOLOGACION----------*/
  insHomologacion: function( data ) 
  {
    var deferred = $q.defer();
    $http.post( appSettings.restApiServiceBaseUri + 'Transacciones/insHomologacion',data)
    .then(successCallback, errorCallback);
    function successCallback(data)
    {
        deferred.resolve( data );
    }
    function errorCallback(error)
    {
        deferred.reject( error );
    }
    return deferred.promise;
  },
  edtHomologacion: function( data ) 
  {
    var deferred = $q.defer();
    $http.post( appSettings.restApiServiceBaseUri + 'Transacciones/edtHomologacion',data)
    .then(successCallback, errorCallback);
    function successCallback(data)
    {
        deferred.resolve( data );
    }
    function errorCallback(error)
    {
        deferred.reject( error );
    }
    return deferred.promise;
  },
  /*------------DATOS_HOMOLOGACION----------*/

  /*---------TC_UBICACION_GEOGRAFICA---------*/
  getUbicacionCentro: function(p_id_despacho) 
  {
    var deferred = $q.defer();
    $http.get( appSettings.restApiServiceBaseUri + 'Transacciones/despacho/'+p_id_despacho+'/getUbicacionCentro')
    .then(successCallback, errorCallback);
      function successCallback(data)
      {
        deferred.resolve( data );
      }
      function errorCallback(error)
      {
        deferred.reject( error );
      }
    return deferred.promise;
  },
  /*---------TC_UBICACION_GEOGRAFICA---------*/


  /*----------GENERACION_INVITACION----------*/
  getInvitacionCaso: function(p_id_expediente,p_id_sesion,p_no_sesion) 
  {
    window.open(appSettings.restApiServiceBaseUri + 'Transacciones/expediente/'+p_id_expediente+
                                                                '/sesion/'+p_id_sesion+
                                                               '/no_sesion/'+p_no_sesion+'/InvitacionCaso', '_blank');
  },
  getInvitacionRevisionCaso: function(p_id_expediente,p_id_sesion,p_no_sesion) 
  {
    window.open(appSettings.restApiServiceBaseUri + 'Transacciones/expediente/'+p_id_expediente+
                                                                '/sesion/'+p_id_sesion+
                                                               '/no_sesion/'+p_no_sesion+'/InvitacionRevisionCaso', '_blank');
  },
  /*----------GENERACION_INVITACION----------*/

  /*-----------GENERACION_CARATULA-----------*/
  getCaratulaCaso: function(p_id_expediente) 
  {
    window.open(appSettings.restApiServiceBaseUri + 'Transacciones/expediente/'+p_id_expediente+'/CaratulaCaso', '_blank');
  },
  /*-----------GENERACION_CARATULA-----------*/

  /*-----------GENERACION_EVOLUCION-----------*/
  getEvolucionCaso: function(p_id_expediente) 
  {
    window.open(appSettings.restApiServiceBaseUri + 'Transacciones/expediente/'+p_id_expediente+'/EvolucionCaso', '_blank');
  },
  /*-----------GENERACION_EVOLUCION-----------*/

  /*-----------GENERACION_REGISTRO-----------*/
  getRegistroCaso: function(p_id_expediente,p_id_sesion,p_no_sesion) 
  {
    window.open(appSettings.restApiServiceBaseUri + 'Transacciones/expediente/'+p_id_expediente+
                                                                '/sesion/'+p_id_sesion+
                                                               '/no_sesion/'+p_no_sesion+'/RegistroCaso', '_blank');
  },
  /*-----------GENERACION_REGISTRO-----------*/
  
  /*------------GENERACION_ACTAS-------------*/
  getActaCasoIncompareciente: function(p_id_expediente) 
  {
    window.open(appSettings.restApiServiceBaseUri + 'Transacciones/expediente/'+p_id_expediente+
                                                                '/ActaCasoIncompareciente', '_blank');
  },
  getActaCasoExtramediacion: function(p_id_expediente) 
  {
    window.open(appSettings.restApiServiceBaseUri + 'Transacciones/expediente/'+p_id_expediente+
                                                                '/ActaCasoExtramediacion', '_blank');
  },
  getActaCasoSinAcuerdo: function(p_id_expediente) 
  {
    window.open(appSettings.restApiServiceBaseUri + 'Transacciones/expediente/'+p_id_expediente+
                                                                '/ActaCasoSinAcuerdo', '_blank');
  },
  getActaCasoDevolucionExpediente: function(p_id_expediente) 
  {
    window.open(appSettings.restApiServiceBaseUri + 'Transacciones/expediente/'+p_id_expediente+
                                                                '/OficioCasoDevolucionExpediente', '_blank');
  },
  getSolicitudHomologacionCaso: function(p_id_expediente) 
  {
    window.open(appSettings.restApiServiceBaseUri + 'Transacciones/expediente/'+p_id_expediente+
                                                                '/SolicitudHomologacionCaso', '_blank');
  },
  getActaCasoRevision: function(p_id_expediente,p_id_sesion) 
  {
     window.open(appSettings.restApiServiceBaseUri + 'Transacciones/expediente/'+p_id_expediente+
                                                                 '/sesion/'+p_id_sesion+
                                                                '/ActaCasoRevision', '_blank');
  }
  /*------------GENERACION_ACTAS-------------*/
  }                                                                                                
}]);